import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../../styles/colors';
import { Label } from './Label';

export interface InputProps {
  id: string;
  label?: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onKeyUp?: (event: any) => void;
}

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 2.5rem;
`;

export const InputInnerWrapper = styled.div`
  position: relative;
  height: 3.625rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: stretch;
`;

export const InputBackground = styled.div`
  position: absolute;
  top: 7.5px;
  left: 7.5px;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, #3b69b0 -100%, #9dcff3 120%);
  z-index: 1;
`;

export const StyledInput = styled.input`
  border: none;
  color: ${Colors.grayDark};
  background-color: ${Colors.white};
  font-size: 0.875rem;
  padding: 0 1rem;
  z-index: 2;
  margin: 0 7.5px 7.5px 0;
  flex: 1;
  box-shadow: inset 0 0 0 1px ${Colors.white}, inset 0 0 0 100px ${Colors.white};

  :-webkit-autofill,
  :-webkit-autofill:hover,
  :-webkit-autofill:focus {
    background-color: ${Colors.white};
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${Colors.gray};
    font-size: 0.875rem;
  }

  &:focus {
    outline: none;
  }
`;

export const Input: FC<InputProps> = (props) => {
  const { value, placeholder, type, id, onChange } = props;

  return (
    <InputWrapper>
      <Label for={props.id}>{props.label}</Label>
      <InputInnerWrapper>
        <InputBackground />
        <StyledInput
          id={id}
          type={`${type ? type : 'text'}`}
          placeholder={`${placeholder ? placeholder : 'Hier eingeben'}`}
          value={value}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            onChange(event.target.value);
          }}
          onKeyUp={props.onKeyUp}
        />
      </InputInnerWrapper>
    </InputWrapper>
  );
};
